import React from 'react';
import PropTypes from 'prop-types';
import TextField from '../../../TextField';

const TextFilter = ({ onChange, operator, settings, suggestions, ...props }) => {
  const handleChange = (ev, newValue) => {
    if (onChange && typeof onChange === 'function') {
      onChange({}, [newValue]);
    }
  };

  return <TextField {...props} onChange={handleChange} />;
};

TextFilter.propTypes = {
  onChange: PropTypes.func,
  operator: PropTypes.string,
  settings: PropTypes.object,
  suggestions: PropTypes.array,
};

TextFilter.defaultProps = {
  onChange: undefined,
  operator: undefined,
  settings: {},
  suggestions: [],
};

export default TextFilter;
